<template>
    <div class="map-page map-page-create-post" :class="{'map-loading': loading }">
        <div class="map-page-content map-center-layout">
            <h1 class="map-page-title">Edit {{ model.name }}</h1>
            <loader />
            <form>
                <label>Content</label>
                <div style="width: 100%; position: relative">
                    <laraberg-editor v-if="!loading" v-model="model.content" />
                </div>
                <dropdown
                    placeholder="Spotlight type"
                    v-model="model.spotlight_type"
                    :options="PostType"
                    @select="change_spotlight_type"
                    >
                </dropdown>
                <dropdown
                    placeholder="Spotlight post"
                    v-model="model.spotlight_post_id"
                    :options="posts"
                    >
                </dropdown>
                <footer>
                    <Button
                        class="map-cancel"
                        @click.prevent="$router.push({ name: 'CentersList' })"
                        >
                        CANCEL
                    </Button>
                    <Button
                        class="map-save"
                        @click.prevent="save"
                        >
                        SAVE
                    </Button>
                </footer>
            </form>
        </div>
    </div>
</template>

<script>
    import Dropdown from '@/components/Inputs/Dropdown';
    import Button from '@/components/Buttons/Button';
    import Loader from '@/components/Loader';
    import LarabergEditor from '@/components/LarabergEditor';

    import { CenterService, PostService, PostType, PostModel } from '@/services';

    export default
    {
        name: 'CentersEdit',
        components:
        {
            Dropdown,
            Button,
            Loader,
            LarabergEditor,
        },
        setup()
        {
            const post_types = [];

            for (let key in PostType)
            {
                if (key === 'LESSON')
                {
                    continue;
                }

                post_types.push({
                    value: PostType[key],
                    label: key,
                });
            }

            return {
                PostType: post_types,
            };
        },
        data()
        {
            return {
                loading: true,
                posts: [],
                model:
                {
                    spotlight_post_id: 0,
                    spotlight_type: '',
                    content: '',
                },
            };
        },
        computed:
        {
            user()
            {
                return this.$store.getters['Auth/user'];
            },
        },
        async created()
        {
            this.loading = true;

            await this.get_center(this.$route.params.id);
            await this.get_posts();

            this.loading = false;
        },
        methods:
        {
            async get_center(id)
            {
                const data = await CenterService.get(id);

                this.model = {...this.model, ...data.data}

                if (this.model.spotlight_type)
                {
                    this.model.spotlight_type = PostModel[this.model.spotlight_type.replace('App\\Models\\', '')];
                }
            },

            async get_posts()
            {
                const data = await PostService.all(this.model.spotlight_type);

                this.posts = data.data.data;

                this.posts.forEach((item) =>
                {
                    item.value = item.id;
                    item.label = item.title;
                });
            },

            async save()
            {
                CenterService.update(this.$route.params.id, this.model).then(() =>
                {
                    this.$toast.success('Center was successfully updated!');
                },
                (error) =>
                {
                    if (error.data.message)
                    {
                        this.$toast.error(error.data.message);
                    }
                    else
                    {
                        this.$toast.error('Something went wrong. Please try again!');
                    }
                });
            },

            async change_spotlight_type()
            {
                await this.get_posts();
            },
        }
    }
</script>
